/**
 * A follow-up on this room as a row says it, whichever layout draws the row: on or off for this room with a way back,
 * and the plain line under its name.
 */
import type { BoardCards } from "../../../shared/types";
import type { BoardHost } from "../host";

export type Mail = BoardCards["mail"];

/** On or off for this room, said with a way back. */
/** The follow-up's own name, the one Automations shows; the card's label is only what the read wrote first. */
export function followName(host: BoardHost, m: Mail): string {
  return (m.automationId ? host.followUpRows.get(m.automationId)?.name : undefined) || m.label;
}

export function flipFollowUp(host: BoardHost, m: Mail): void {
  const name = followName(host, m);
  host.dispatch({ type: "toggle", id: m.id });
  host.toast(m.on ? `“${name}” is off for this room.` : `“${name}” is on for this room.`, {
    label: "Undo",
    run: () => host.dispatch({ type: "toggle", id: m.id }),
  });
}
